import { render, staticRenderFns } from "./scoreTable.vue?vue&type=template&id=63280c32&"
import script from "./scoreTable.vue?vue&type=script&lang=js&"
export * from "./scoreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports